import { Button, Card, Col, Layout, Modal, Tabs, TabsProps } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TuLieuDinhKem from "./HinhAnhDinhKem";
import ThongTinTaiLieuVideo from "./ThongTinHinhAnhForm";
import { checkVaiTroUserLogin } from "src/util/Commom";
import {
  SendOutlined,
  CloseCircleOutlined,
  CheckCircleFilled
} from "@ant-design/icons";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import { apiCaller } from "src/util/apiCaller";
import { MessageStatusError } from "src/util/MessageStatus";
import { toNumber } from "lodash";
import { selectData } from "src/appRedux/reducers/commonApiReducer";

interface NhomTaiLieu {
  id: number;
  tenNhomTuLieu: string;
}
const DanhSachHinhAnhForm = ({ status }: any) => {
  const navigate = useNavigate();
  const useInfo = useAppSelector(selectUser);
  const isDuyetXuatBan = checkVaiTroUserLogin(useInfo, "DUYET_XUAT_BAN");
  const isAdmin = checkVaiTroUserLogin(useInfo, "ADMIN");
  const { hinhanhid, idnhomtulieu } = useParams();
  const [idTuLieu, setIdTuLieu] = useState(hinhanhid);
  const [keyTab, setKeyTab] = useState("thong-tin");
  const [trangThai, setTrangThai] = useState(undefined);
  const [tenNhomTuLieu, setTenNhomTuLieu] = useState("");
  const listNhomTaiLieu = useAppSelector(selectData)
  .listNhomTaiLieu as NhomTaiLieu[];

  useEffect(() => {
    if (idnhomtulieu && listNhomTaiLieu) {
      const itemNhomTL = listNhomTaiLieu.find(
        (value: any) => value.id === parseInt(idnhomtulieu, 10)
      );
      const tenNhomTuLieu = itemNhomTL ? itemNhomTL.tenNhomTuLieu : "";
      setTenNhomTuLieu(tenNhomTuLieu);
    }
  }, [idnhomtulieu, listNhomTaiLieu]);

  const items: TabsProps["items"] = [
    {
      key: "thong-tin",
      label: "Thông tin tài liệu video",
      children: (
        <ThongTinTaiLieuVideo
          setIdTuLieu={setIdTuLieu}
          setKeyTab={setKeyTab}
          setTrangThais={setTrangThai}
        />
      )
    },
    {
      key: "tu-lieu",
      label: "Tài liệu đính kèm",
      children: <TuLieuDinhKem idTuLieu={idTuLieu} keyTab={keyTab} />
    }
  ];

  // Chỉ hiển thị tab "Tài liệu đính kèm" nếu idTulieu có giá trị
  const filteredItems = idTuLieu
    ? items
    : items.filter((item) => item.key !== "tu-lieu");

  const onChangeTab = (key: string) => {
    setKeyTab(key);
  };

  const goBack = () => {
    navigate(`/hinh-anh/idnhomtulieu/${idnhomtulieu}`);
  };

  const handleGuiDuyet = (trangThai: number, type: string) => {
    const title = type === "gui" ? "gửi" : type === "huy" ? "hủy" : "";
    Modal.confirm({
      width: 500,
      title: "THÔNG BÁO",
      content: `Bạn sẽ ${title} xuất bản tài liệu hình ảnh này. Nhấn Đồng ý để xác nhận.`,
      onOk(e) {
        e();
        handleSubmitGui(idTuLieu, trangThai);
      },
      okText: "Đồng ý",
      onCancel() {},
      cancelText: "Hủy"
    });
  };

  const handleSubmitGui = async (id: any, TT: number) => {
    const configAPI = {
      url: `api/tulieu/${id}/${TT}`,
      method: "PUT",
      value: null,
      apiType: "EDIT",
      getName: "editTrangThai"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        goBack();
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
    }
  };

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            {hinhanhid
              ? `Chỉnh sửa ${tenNhomTuLieu}`
              : `Thêm mới ${tenNhomTuLieu} `}
          </h2>
        </Col>
      </div>
      <Card>
        <Tabs
          onChange={onChangeTab}
          activeKey={keyTab}
          defaultActiveKey="thong-tin"
          items={filteredItems}
        />
        {idTuLieu && (
          <div style={{ textAlign: "center", padding: 10 }}>
            {(trangThai === 1 || trangThai === 4) && (
              <Button
                onClick={() => handleGuiDuyet(2, "gui")}
                type="primary"
                htmlType="submit"
              >
                <SendOutlined />
                Gửi duyệt xuất bản
              </Button>
            )}
            {(trangThai === 1 || trangThai === 2) && (isDuyetXuatBan || isAdmin) && (
              <Button
                style={{ margin: "0 15px" }}
                className="heading-button-addnew btn"
                type="primary"
                onClick={() => handleGuiDuyet(3, "xuat")}
                icon={<CheckCircleFilled />}
              >
                Duyệt xuất bản
              </Button>
            )}
            {(trangThai === 1 || trangThai === 3) && (isDuyetXuatBan || isAdmin) && (
              <Button
                className="heading-button-addnew btn"
                type="primary"
                onClick={() => handleGuiDuyet(4, "huy")}
                icon={<CloseCircleOutlined />}
                color="danger"
                variant="solid"
              >
                Hủy xuất bản
              </Button>
            )}
          </div>
        )}
      </Card>
    </Layout>
  );
};

export default DanhSachHinhAnhForm;
